export default __webpack_public_path__ + "static/media/163.d69dd0ea.gif";